import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import EcoLunchDeck from "./components/EcoLunchDeck";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<EcoLunchDeck />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
